export default "__VITE_ASSET__6j$0sr6V__"